import { CustomerDisplayProductCollection, CustomerDisplayProductModel } from "@GeriMed/Type/ApiModelsExt";
import {
    ApiParameter,
    get,
    HasPagingParameters,
    patch,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { ProductPriceModel,ProductDto } from "@insite/client-framework/Types/ApiModels";

export interface GetOfficeSuppliesApiParameter extends ApiParameter, HasPagingParameters {
    customerNumber: string;
}

const serviceUri = "/api/v1/officesupplies";
const productServiceUri = "/api/v1/products/";

export async function getProducts(parameter: GetOfficeSuppliesApiParameter): Promise<CustomerDisplayProductCollection> {
    const url = serviceUri + "?v=" + (Math.random() * 100);
    const result = await get<CustomerDisplayProductCollection>(`${url}`);
    return result;
}
export async function getOfficeSuppliesListProducts(parameter: GetOfficeSuppliesApiParameter): Promise<CustomerDisplayProductModel[]> {
    const url = serviceUri + "?v=" + (parameter.customerNumber);
    const result = await get<CustomerDisplayProductCollection>(`${url}`);
    return result.productList;
}
export async function getProductPrice(product: ProductDto, configuration?: string[]): Promise<ProductPriceModel> {
    const newParameter = getProductPriceParams(product, configuration);
    const url = `${productServiceUri}${product.id}/price`;
    const result = await get<ProductPriceModel>(`${url}`,newParameter);
    return result;
}


function getProductPriceParams(product: ProductDto, configuration?: string[]): any {
    return {
        unitOfMeasure: product.selectedUnitOfMeasure,
        qtyOrdered: product.qtyOrdered,
        configuration: configuration
    };
}


